/**
 * PfPageHeading — a step's own title and description, at the top of its content.
 *
 * Extracted from the configuration step, which was the only step that had one.
 * Instructions, Billing and Summary put their title (and sometimes a subtitle)
 * into `StepShell`'s sticky top bar instead, where it reads as a bar label in
 * small text rather than as the page's heading — so those three looked like they
 * had no title at all. The top bar keeps its own default ("Your order"), which
 * is what the catalogue and configuration steps already show.
 */

import React from 'react'
import { Stack, Typography } from '@mui/material'

import { GRAY_700, GRAY_900, RhetorikFontFamily } from 'constants/styling/theme'

interface Props {
  title: string
  /** Omitted only where a step genuinely has nothing to add to its title. */
  description?: string
}

/**
 * @example
 * <PfPageHeading title={t('…:billing.page_title')} description={t('…:billing.page_subtitle')} />
 */
export const PfPageHeading: React.FC<Props> = ({ title, description }) => (
  <Stack gap={0.4} sx={{ mt: 2.4, mb: 1.6 }} data-cy="pf-revamp-page-heading">

    <Typography
      variant="text-2xl"
      fontWeight={400}
      color={GRAY_900}
      fontFamily={RhetorikFontFamily}
    >
      {title}
    </Typography>

    {description &&
      <Typography variant="text-sm" color={GRAY_700}>
        {description}
      </Typography>
    }

  </Stack>
)
